import { Component, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Material, MaterialProduct } from '@isophi/teachers-shared';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { MaterialService, SortType } from '../../services/material.service';

@Component({
    selector: 'app-materials',
    templateUrl: './materials.component.html',
    styleUrls: ['./materials.component.scss'],
    standalone: false
})


export class MaterialsComponent implements OnDestroy {
  showMaterialData$: BehaviorSubject<string> = new BehaviorSubject(SortType.DIAGNOSTIC);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  SortType: typeof SortType = SortType;

  diagnosticProducts$: Observable<MaterialProduct[]>;

  educationalProducts$: Observable<MaterialProduct[]>;

  diagnosticMaterials$: Observable<Material[][]>;

  educationalMaterials$: Observable<Material[][]>;

  private _subs: Subscription[] = [];

  constructor(
    protected materialService: MaterialService,
    private router: Router
  ) {
    this.diagnosticProducts$ = this.materialService.diagnosticProducts$;
    this.diagnosticMaterials$ = this.materialService.diagnosticMaterials$;
    this.educationalProducts$ = this.materialService.educationalProducts$;
    this.educationalMaterials$ = this.materialService.educationalMaterials$;

    this._subs.push(
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          let url = event.url.split('/')[3];

          if (url.includes('?')) {
            url = url.split('?')[0];
          }

          this.showMaterialData$.next(url);
        }
      })
    )
  }

  ngOnDestroy(): void {
    this._subs.forEach((_sub) => _sub.unsubscribe());
  }
}
